export const personalDataFieldsConfig = [
    { key: "first_name", type: "input" },
    { key: "last_name", type: "input" },
    { key: "email", type: "input" },
    { key: "telegram_tag", type: "input", placeholder: "@user_tag" },
    { key: "password", type: "input" },
    { key: "desk_id", type: "dropdown", options: 'deskOptions' }, 
    { key: "role", type: "dropdown", endpoint: "/admin/user/roles", options: 'roleOptions' },
];
